import * as actionTypes from "../actionTypes";
import * as actionUrl from "../../../config/actionUrl";
import { convertObjectToArray } from "../../../util/utility";
import axios from "axios";

export const createViomeKitStart = () => {
  return {
    type: actionTypes.CREATE_VIOME_KIT_START
  };
};
export const createViomeKitFail = errorResponse => {
  return {
    type: actionTypes.CREATE_VIOME_KIT_FAIL,
    error: errorResponse.debugMessage
  };
};

export const createViomeKitSuccess = productResponse => {
  return {
    type: actionTypes.CREATE_VIOME_KIT_SUCCESS,
    result: convertObjectToArray(productResponse.response, "testName"),
    message: productResponse.message
  };
};

export const createViomeKit = formData => {
  return dispatch => {
    dispatch(createViomeKitStart());
    axios
      .post(actionUrl.CREATE_VIOME_KIT_URL, formData, {
        headers: {
          "Content-Type": "application/json"
        },
        mode: "cors",
        withCredentials: true,
      })
      .then(res => {
        dispatch(createViomeKitSuccess(res.data.ProductResponse));
      })
      .catch(err => {
        dispatch(createViomeKitFail(err.response.data.producterrorresponse));
      });
  };
};

export const updateViomeKitStart = () => {
  return {
    type: actionTypes.UPDATE_VIOME_KIT_START
  };
};

export const updateViomeKitFail = errorResponse => {
  return {
    type: actionTypes.UPDATE_VIOME_KIT_FAIL,
    error: errorResponse.debugMessage
  };
};

export const updateViomeKitSuccess = productResponse => {
  return {
    type: actionTypes.UPDATE_VIOME_KIT_SUCCESS,
    result: convertObjectToArray(productResponse.response, "testName"),
    message: productResponse.message
  };
};

export const updateViomeKit = formData => {
  return async dispatch => {
    dispatch(updateViomeKitStart());
    axios
      .post(actionUrl.UPDATE_VIOME_KIT_URL, formData, {
        headers: {
          "Content-Type": "application/json"
        },
        mode: "cors",
        withCredentials: true,
      })
      .then(res => {
        dispatch(updateViomeKitSuccess(res.data.ProductResponse));
      })
      .catch(err => {
        dispatch(updateViomeKitFail(err.response.data.producterrorresponse));
      });
  };
};

export const removeViomeKitStart = () => {
  return {
    type: actionTypes.DELETE_VIOME_KIT_START
  };
};

export const removeViomeKitFail = errorResponse => {
  return {
    type: actionTypes.DELETE_VIOME_KIT_FAIL,
    error: errorResponse.debugMessage
  };
};

export const removeViomeKitSuccess = productResponse => {
  return {
    type: actionTypes.CREATE_VIOME_KIT_SUCCESS,
    result: convertObjectToArray(productResponse.response, "testName"),
    message: productResponse.message
  };
};

export const removeViomeKit = formData => {
  return async dispatch => {
    dispatch(removeViomeKitStart());
    axios
      .post(actionUrl.DELETE_VIOME_KIT_URL, formData, {
        headers: {
          "Content-Type": "application/json"
        },
        mode: "cors",
        withCredentials: true,
      })
      .then(res => {
        dispatch(removeViomeKitSuccess(res.data.ProductResponse));
      })
      .catch(err => {
        dispatch(removeViomeKitFail(err.response.data.producterrorresponse));
      });
  };
};
